module.exports = __webpack_public_path__ + "img/human-dummy-practice.52c62d8b.svg";